// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apply a natural box layout model to all elements, but allowing components to change */
html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

html,
body {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  line-height: 1;
  font-weight: 300;
  font-family: 'Roboto', 'Ubuntu', Sans-serif;
  height: 100%;
  /* width: 100vw;  THIS MIGHT BREAK AWARE */
}

html {
  font-size: 16px;
}

input[type='submit'],
input[type='reset'],
input[type='button'],
button {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}

/* Reset \`button\` and button-style \`input\` default styles */
input[type='submit'],
input[type='reset'],
input[type='button'],
button {
  background: none;
  border: 0;
  color: inherit;
  /* cursor: default; */
  font: inherit;
  line-height: normal;
  overflow: visible;
  padding: 0;
  margin: 0;
  -webkit-appearance: button; /* for input */
  -webkit-user-select: none; /* for button */
  -moz-user-select: none;
  -ms-user-select: none;
}
input::-moz-focus-inner,
button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/* Add in support for sup and sub elements */
/* https://gist.github.com/unruthless/413930 */
sub,
sup {
  font-size: 75%;
}

sup {
  vertical-align: super;
}

sub {
  vertical-align: sub;
}

button:focus {
  outline: 0 !important;
} /* Incubment upon devs to provide focus state for buttons. */

#printPortal {
  display: none;
}

@media print {
  #printPortal {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .MuiDialog-root {
    display: none;
  }
  .MuiTooltip-popper {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/styles/global.css"],"names":[],"mappings":"AAAA,wFAAwF;AACxF;EACE,sBAAsB;AACxB;AACA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,0BAA0B,EAAE,cAAc;EAC1C,yBAAyB,EAAE,eAAe;EAC1C,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA,4CAA4C;AAC5C,8CAA8C;AAC9C;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB,EAAE,4DAA4D;;AAE9D;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Apply a natural box layout model to all elements, but allowing components to change */\nhtml {\n  box-sizing: border-box;\n}\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nhtml,\nbody {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  line-height: 1;\n  font-weight: 300;\n  font-family: 'Roboto', 'Ubuntu', Sans-serif;\n  height: 100%;\n  /* width: 100vw;  THIS MIGHT BREAK AWARE */\n}\n\nhtml {\n  font-size: 16px;\n}\n\ninput[type='submit'],\ninput[type='reset'],\ninput[type='button'],\nbutton {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n/* Reset `button` and button-style `input` default styles */\ninput[type='submit'],\ninput[type='reset'],\ninput[type='button'],\nbutton {\n  background: none;\n  border: 0;\n  color: inherit;\n  /* cursor: default; */\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  margin: 0;\n  -webkit-appearance: button; /* for input */\n  -webkit-user-select: none; /* for button */\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\ninput::-moz-focus-inner,\nbutton::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/* Add in support for sup and sub elements */\n/* https://gist.github.com/unruthless/413930 */\nsub,\nsup {\n  font-size: 75%;\n}\n\nsup {\n  vertical-align: super;\n}\n\nsub {\n  vertical-align: sub;\n}\n\nbutton:focus {\n  outline: 0 !important;\n} /* Incubment upon devs to provide focus state for buttons. */\n\n:global(#printPortal) {\n  display: none;\n}\n\n@media print {\n  :global(#printPortal) {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  :global(.MuiDialog-root) {\n    display: none;\n  }\n  :global(.MuiTooltip-popper) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
